
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ServiceStatus enum
 */
class ServiceStatus {
  /**
   * Initialize enum with a given value
   * @param {ServiceStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ServiceStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ServiceStatus}
   * @param {!ServiceStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ServiceStatus)) {
      throw new TypeError('Instance of ServiceStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ServiceStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ServiceStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ServiceStatus.NOT_SERVING.value) {
      return 'NOT_SERVING'
    }
    if (this.value === ServiceStatus.SERVING.value) {
      return 'SERVING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ServiceStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ServiceStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ServiceStatus} Created enum
   */
  static fromObject (other) {
    return new ServiceStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ServiceStatus.NOT_SERVING = new ServiceStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ServiceStatus.SERVING = new ServiceStatus(0 + 1)

export { ServiceStatus };

/**
 * Fast Binary Encoding ServiceStatus field model
 */
class FieldModelServiceStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelServiceStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelServiceStatus}
   * @param {ServiceStatus=} defaults Default value, defaults is new ServiceStatus()
   * @returns {!ServiceStatus} Result value
   */
  get (defaults = new ServiceStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ServiceStatus(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelServiceStatus}
   * @param {!ServiceStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelServiceStatus };
